import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage"; // Import compat storage
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, getFirestore } from "firebase/firestore";

// REPLACE WITH YOUR FIREBASE CONFIGURATION
const firebaseConfig = {
apiKey: "AIzaSyBAlyxM9zsD60wt3Ynku586sM5Raee4GQY",
  authDomain: "kayakkandy-family.firebaseapp.com",
  projectId: "kayakkandy-family",
  storageBucket: "kayakkandy-family.firebasestorage.app",
  messagingSenderId: "446541094844",
  appId: "1:446541094844:web:9a7a635221ed1bf01515b9"
};

// Initialize Firebase (Singleton pattern)
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Initialize Firestore (Modular)
let db;
try {
  db = initializeFirestore(app as any, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  });
} catch (e) {
  db = getFirestore(app as any);
}

// Initialize Storage (Compat) - Use compat to align with Auth for reliable uploads
const storage = firebase.storage();

export { db, storage };
export const auth = firebase.auth();

export const getSecondaryApp = () => {
  return firebase.initializeApp(firebaseConfig, "SecondaryApp");
}